import React from 'react';
import './NewQuotations.scss';

const NewQuotations = () => {

  return (
    <div>

    </div>
  );

}
export default NewQuotations;